import React from 'react';

export type DesignInputProps = {
  name: string;
  type: string;
  max?: string | number | undefined;
  min?: string | number | undefined;
  step: string | number | undefined;
  id?: string | undefined;
  onChanceHandler: ((e: any) => void) | undefined;
  value: string | number | undefined;
  className?: string;
  placeHolder?: string | undefined;
  readonly?: boolean;
  onClick?: ((e: any) => void) | undefined;
};

const DesignInput = ({
  name,
  type,
  max,
  min,
  step,
  id,
  value,
  className,
  placeHolder,
  readonly,
  onClick,
  onChanceHandler,
}: DesignInputProps) => (
  <input
    name={name}
    type={type}
    max={max}
    min={min}
    step={step}
    id={id}
    className={`mt-2 w-full rounded-sm p-2 leading-6 outline outline-1 hover:outline-design-red dark:bg-design-black dark:[color-scheme:dark] ${className}`}
    onChange={onChanceHandler}
    value={value}
    placeholder={placeHolder}
    readOnly={readonly}
    onClick={onClick}
  />
);

DesignInput.defaultProps = {
  className: '',
  id: undefined,
  min: 0,
  max: '',
  placeHolder: undefined,
  readonly: false,
  onClick: undefined,
};

export default DesignInput;
